/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-17 14:37:18
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-05-23 14:43:20
 * @FilePath: \english_admin\src\assets\css\theme.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// assets/js/model.js
export const themes = {
    default: {
      primaryColor: `#304156`,//`rgb(${74}, ${144},${226})`,
      primaryTextColor:  `#fff`,//`rgb(${233}, ${233},${233})`
    },
    dark: {
      primaryColor: `#304156`,
      primaryTextColor: `#fff`
    },
    blue: {
      primaryColor: `#66b1ff`,
      primaryTextColor: `#fff`
    },
    green: {
      primaryColor: `#85ce61`,
      primaryTextColor: `#fff`
    },
    grey: {
      primaryColor: `#8896b3`,
      primaryTextColor: `#fff`
    },
    yellow: {
      primaryColor: `#ebb563`,
      primaryTextColor: `#fff`
    },
    red: {
      primaryColor: `#f78989`,
      primaryTextColor: `#fff`
    }
  }
  


// WEBPACK FOOTER //
// ./src/assets/css/model.js